// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "betbotfront-20190308151938-hostingbucket",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://betbotfront-20190308151938-hostingbucket.s3-website-us-east-1.amazonaws.com",
    "aws_appsync_graphqlEndpoint": "https://oxj3ykvl75f5vbtrakatroplqe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3wkdzqv2qjca5meqj43r22jvx4"
};


export default awsmobile;
